const Fetcher = require('od-modules/utils/fetcher');
const Schemas = require('./app.schemas');
const searchFormatter = require('./search/search_formatter');
const xsellUtils = require('od-modules/utils/xsell.utils');
const Flights = {};
const MAX_CHILDREN = 6;
const MAX_INFANTS = 4;
const tv4 = window.tv4 = window.tv4 || require('third-party/tv4.min');
const logger = require('od-modules/utils/logger');

const TYPES = {
    oneWayTrip: 'ONE_WAY',
    roundTrip: 'ROUND_TRIP',
    multipleTrip: 'MULTIPLE_DESTINATIONS',
};
const getCheckoutDateFromReturnFlight = function(searchSegments) {
    return searchSegments.length > 1 ? searchSegments[1].dateStr : Odigeo.Utils.getNextDay(searchSegments[0].dateStr);
};
const getGeoData = (pos) => Odigeo.Settings.property('geoServiceUrlFormatter')('geocomplete') +
    `;latitude=${pos.coords.latitude};longitude=${pos.coords.longitude}`;

Flights.searchParamsParser = function(p, keyParams) {
    const params = decodeURI(p);
    const urlParams = Odigeo.Utils.parseHashParameters(params);

    return searchFormatter.getSearchParamsFromUrl(urlParams, keyParams);
};

Flights.getPath = function(options) {
    return Odigeo.Utils.templateLiteral('${host}${path}/${flightData}#${page}/${searchParams}', {
        host: location.hostname,
        path: Odigeo.Settings.getProperty('appContext'),
        page: options.page || Odigeo.History.getPageNameFromFragment(),
        flightData: options.flightData,
        searchParams: options.searchParams,
    });
};

Flights.searchParamsStringify = function(params, keyParams) {
    return searchFormatter.searchParamsStringify(params, keyParams);
};

function pickKidAndInfantAges(params, numChildren, numInfants) {
    return searchFormatter.pickKidAndInfantAges(params, numChildren, numInfants);
}

Flights.isDynpackFlightsResults = function(currentPage) {
    return searchFormatter.isDynpackFlightsResults(currentPage);
};

Flights.isAccommodationResults = function(currentPage) {
    return searchFormatter.isAccommodationResults(currentPage);
};

Flights.getSearchData = function(params, currentPage, paramsParserFun) {
    return searchFormatter.getSearchData(params, currentPage, paramsParserFun);
};

Flights.purgePreviousSearches = function(raw) {
    var data;
    if (raw) {
        try {
            data = JSON.parse(raw);
        } catch (error) {
            logger.error(error);
            data = [];
        }
    } else {
        data = [];
    }

    if (tv4.validate(data, Schemas.searchDataSchema)) {
        Odigeo._.each(data, function(search, idx) {
            if (!tv4.validate(search, Schemas.searchData)) {
                delete data[idx];
            }
        });
        data = Odigeo._.compact(data);
    } else {
        data = [];
    }

    return data;
};

Flights.purgeTravellers = function(raw) {
    var data;

    if (raw) {
        try {
            data = JSON.parse(raw);
        } catch (error) {
            logger.error(error);
            data = {};
        }
    } else {
        data = {};
    }

    if (tv4.validate(data, Schemas.travellersSchema)) {
        for (var type in data) {
            if (data[type]) {
                for (var key in data[type]) {
                    if (type !== 'defaultTraveler') {
                        if (type === 'adults') {
                            if (!tv4.validate(data[type][key], Schemas.travellerAdults)) {
                                delete data[type][key];
                            }
                        } else {
                            if (!tv4.validate(data[type][key], Schemas.travellerChildren)) {
                                delete data[type][key];
                            }
                        }
                    }
                }
            }
        }
    } else {
        data = {'adults': {}, 'children': {}, 'infants': {}};
    }
    return data;
};

Flights.onRouteChange = function(paxPageName, route) {
    // When user press back button at confirmation page, he is redirected to details page
    // In that case -> show error dialog to avoid duplicated bookings
    if (route.from.name === 'confirmation' && route.to.name === paxPageName) {
        Odigeo.UIElements.showSessionExpiredError('alert', true);
    }
};

Flights.checkCookies = function() {
    if (!Odigeo.Device.navigator.hasCookies) {
        var button = {
            text: Odigeo.UIElements.translations.errCookies.button,
            style: 'od-ui-dialog-button-default',
            handler: function() {
                window.location.reload();
            },
        };
        var noCookiesDialog = Odigeo.UIElements.createDialog({
            headerText: Odigeo.UIElements.translations.errCookies.text,
            content: Odigeo.UIElements.translations.errCookies.content,
            buttons: [button],
            dialogClasses: 'dialog_error',
        });

        Odigeo.UIElements.showDialog(noCookiesDialog);
    }
    return Odigeo.Device.navigator.hasCookies;
};

/**
 * FIXME: Refactor this method for god sake.
 */

Flights.roomSetUpMap = {
    '1-0-0': ['1_0_0'],
    '1-0-1': ['1_0_1'],
    '1-0-2': ['1_0_2'],
    '1-1-0': ['1_1_0'],
    '1-1-1': ['1_1_1'],
    '1-2-0': ['1_2_0'],
    '2-0-0': ['2_0_0'],
    '2-0-1': ['2_0_1'],
    '2-0-2': ['2_0_2'],
    '2-1-0': ['2_1_0'],
    '2-1-1': ['2_1_1'],
    '2-1-2': ['1_0_2', '1_1_0'],
    '2-2-0': ['2_2_0'],
    '2-2-1': ['1_1_0', '1_1_1'],
    '2-2-2': ['1_2_0', '1_0_2'],
    '2-3-0': ['1_2_0', '1_1_0'],
    '2-3-1': ['1_2_0', '1_1_1'],
    '2-4-0': ['1_2_0', '1_2_0'],
    '3-0-0': ['3_0_0'],
    '3-0-1': ['3_0_1'],
    '3-0-2': ['2_0_2', '1_0_0'],
    '3-1-0': ['2_0_0', '1_1_0'],
    '3-1-1': ['2_0_1', '1_1_0'],
    '3-1-2': ['2_1_1', '1_0_1'],
    '3-2-0': ['2_1_0', '1_1_0'],
    '3-2-1': ['2_1_0', '1_1_1'],
    '3-2-2': ['2_1_1', '1_1_1'],
    '3-2-3': ['1_0_1', '1_1_1', '1_1_1'],
    '3-3-0': ['2_2_0', '1_1_0'],
    '3-3-1': ['2_2_0', '1_1_1'],
    '3-3-2': ['1_1_1', '1_1_1', '1_1_0'],
    '3-4-0': ['2_2_0', '1_2_0'],
    '3-4-1': ['1_2_0', '1_2_0', '1_0_1'],
    '3-4-2': ['1_2_0', '1_2_0', '1_0_2'],
    '3-5-0': ['1_2_0', '1_2_0', '1_1_0'],
    '3-5-1': ['1_2_0', '1_2_0', '1_1_1'],
    '3-6-0': ['1_2_0', '1_2_0', '1_2_0'],
    '4-0-0': ['2_0_0', '2_0_0'],
    '4-0-1': ['2_0_0', '2_0_1'],
    '4-0-2': ['2_0_1', '2_0_1'],
    '4-1-0': ['2_1_0', '2_0_0'],
    '4-1-1': ['2_1_0', '2_0_1'],
    '4-1-2': ['2_1_1', '2_0_1'],
    '4-2-0': ['2_1_0', '2_1_0'],
    '4-2-1': ['2_1_0', '2_1_1'],
    '4-2-2': ['2_1_1', '2_1_1'],
    '4-3-0': ['2_2_0', '2_1_0'],
    '4-3-1': ['2_2_0', '2_1_1'],
    '4-3-2': ['2_1_0', '1_2_0', '1_0_2'],
    '4-4-0': ['2_2_0', '2_2_0'],
    '4-4-1': ['2_0_1', '1_2_0', '1_2_0'],
    '4-5-0': ['2_2_0', '1_2_0', '1_1_0'],
    '5-0-0': ['3_0_0', '2_0_0'],
    '5-0-1': ['3_0_0', '2_0_1'],
    '5-0-2': ['2_0_1', '2_0_1', '1_0_0'],
    '5-1-0': ['3_0_0', '2_1_0'],
    '5-1-1': ['3_0_0', '2_1_1'],
    '5-1-2': ['2_0_1', '2_1_1', '1_0_0'],
    '5-2-0': ['3_1_0', '2_1_0'],
    '5-2-1': ['3_1_0', '2_1_1'],
    '5-2-2': ['2_1_1', '2_1_1', '1_0_0'],
    '5-3-0': ['3_1_0', '2_2_0'],
    '5-3-1': ['2_1_1', '2_2_0', '1_0_0'],
    '5-4-0': ['2_1_0', '2_1_0', '1_2_0'],
    '6-0-0': ['2_0_0', '2_0_0', '2_0_0'],
    '6-0-1': ['2_0_0', '2_0_0', '2_0_1'],
    '6-0-2': ['2_0_0', '2_0_1', '2_0_1'],
    '6-1-0': ['2_1_0', '2_0_0', '2_0_0'],
    '6-1-1': ['2_1_0', '2_0_0', '2_0_1'],
    '6-1-2': ['2_1_0', '2_0_1', '2_0_1'],
    '6-2-0': ['2_1_0', '2_1_0', '2_0_0'],
    '6-2-1': ['2_1_0', '2_1_0', '2_0_1'],
    '6-3-0': ['2_1_0', '2_1_0', '2_1_0'],
    '7-0-0': ['3_0_0', '2_0_0', '2_0_0'],
    '7-0-1': ['3_0_0', '2_0_0', '2_0_1'],
    '7-0-2': ['3_0_0', '2_0_1', '2_0_1'],
    '7-1-0': ['3_0_0', '2_1_0', '2_0_0'],
    '7-1-1': ['3_0_0', '2_1_0', '2_0_1'],
    '7-2-0': ['3_0_0', '2_1_0', '2_1_0'],
    '8-0-0': ['2_0_0', '2_0_0', '2_0_0', '2_0_0'],
    '8-0-1': ['2_0_0', '2_0_0', '2_0_0', '2_0_1'],
    '8-1-0': ['2_1_0', '2_0_0', '2_0_0', '2_0_0'],
    '9-0-0': ['3_0_0', '3_0_0', '3_0_0'],
};

Flights.validateRooms = function(data) {
    var roomSetUp = Flights.roomSetUpMap[data.numAdults + '-' + data.numChildren + '-' + data.numInfants];
    var afterDealRoomSetUp;
    var dealRoomSetUp;
    var configRooms;

    if (Odigeo._.isUndefined(roomSetUp) && data.numChildren > 2) {
        dealRoomSetUp = Flights.roomSetUpMap['1-2-0'];
        afterDealRoomSetUp = Flights.roomSetUpMap[(data.numAdults - 1) + '-' + (data.numChildren - 2) + '-' + data.numInfants];
        roomSetUp = !Odigeo._.isUndefined(afterDealRoomSetUp) ? dealRoomSetUp.concat(afterDealRoomSetUp) : roomSetUp;
    }

    if (Odigeo._.isUndefined(roomSetUp) && data.numInfants > 2) {
        configRooms = Odigeo._.isUndefined(dealRoomSetUp) ? [1, 0] : [2, 2];
        dealRoomSetUp = Flights.roomSetUpMap[configRooms[0] + '-' + configRooms[1] + '-2'];
        afterDealRoomSetUp = Flights.roomSetUpMap[(data.numAdults - configRooms[0]) + '-' +
        (data.numChildren - configRooms[1]) + '-' + (data.numInfants - 2)];
        roomSetUp = !Odigeo._.isUndefined(afterDealRoomSetUp) ? dealRoomSetUp.concat(afterDealRoomSetUp) : roomSetUp;
    }

    return roomSetUp;
};

Flights.getRoomsParams = function(data) {
    var rooms = Flights.validateRooms(data);
    var nRooms = Odigeo._.size(rooms);
    var params = '';

    Odigeo._.each(rooms, function(room, index) {
        params = params.concat('&q-room-').concat(index).concat('-adults=').concat(room.split('_')[0]);
    });

    return nRooms.toString().concat(params);
};

Flights.getDynpackSearchFunction = function(setRoomSetUp, voidFunction, baseUrl) {
    var mode = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackMode : '';

    if (Odigeo._.isUndefined(voidFunction)) {
        voidFunction = function() {
            return '#';
        };
    }
    if (Odigeo._.isUndefined(baseUrl)) {
        baseUrl = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackUrlBase : '';
    }

    switch (mode) {
        case 'GO':
        case 'OP':

            return function(data) {
                var classMap = {
                    BUSINESS: 'aff',
                    FIRST: 'fst',
                    TOURIST: 'eco',
                    PREMIUM_ECONOMY: 'pre',
                };
                var params;
                var defaults = {
                    typ: 'flighthotel',
                    idpart: Odigeo.SessionScope.idpart,
                    locked_iata: '',
                    dpdapi: 'B',

                    rooms: 1,
                    adt0: 2,
                    enf0: 0,
                    ae01: 0,
                    ae02: 0,
                    adt1: 2,
                    enf1: 0,
                    ae11: 0,
                    ae12: 0,
                    adt2: 2,
                    enf2: 0,
                    ae21: 0,
                    ae22: 0,
                    adt3: 2,
                    enf3: 0,
                    ae31: 0,
                    ae32: 0,
                };

                if (data.searchSegments.length === 2 && data.type === 'roundTrip') {
                    defaults = setRoomSetUp(data, defaults, mode);
                    params = Odigeo._.extend(defaults, {
                        vil_dep: data.searchSegments[0].departure.city,
                        iata_dep: data.searchSegments[0].departure.iata,
                        geo_vil_dep: data.searchSegments[0].departure.geoNodeId,

                        vil_arr: data.searchSegments[0].destination.city,

                        dte_dep: data.searchSegments[0].dateStr,
                        dte_ret: data.searchSegments[1].dateStr,

                        cls: classMap[data.cabinClass] || 'eco',

                        direct: data.directFlightsOnly ? 'oui' : 'non',
                    });

                    if (!Odigeo._.isNull(data.collectionMethod)) {
                        params = Odigeo._.extend(params, {
                            collectionMethodId: data.collectionMethod,
                        });
                    }

                    if (mode === 'OP' && !!data.checkInDate && !!data.checkOutDate) {
                        params = Odigeo._.extend(params, {
                            htl_arr: Odigeo.Utils.formatDateFromString(data.checkInDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                            htl_dep: Odigeo.Utils.formatDateFromString(data.checkOutDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                        });
                    }

                    return baseUrl + '?' + $.param(params);
                } else {
                    return voidFunction;
                }
            };

        // 'ED' or anything else
        default:

            return function(data) {
                var params;
                var defaults = {
                    action: 'engine/DynPackSearch/search',
                    buyPath: 95,
                    auxOrBt: 0,
                    searchMainProductTypeName: 'DYNPACK',

                    departureTime: '0000',
                    returnTime: '0000',

                    numberOfRooms: 1,
                    room0Adults: 2,
                    room1Adults: 2,
                    room2Adults: 2,
                    room3Adults: 2,
                    room0Childs: 0,
                    room0Child0Age: 0,
                    room0Child1Age: 0,
                    room1Childs: 0,
                    room1Child0Age: 0,
                    room1Child1Age: 0,
                    room2Childs: 0,
                    room2Child0Age: 0,
                    room2Child1Age: 0,
                    room3Childs: 0,
                    room3Child0Age: 0,
                    room3Child1Age: 0,
                };

                if (data.searchSegments.length === 2 && data.type === 'roundTrip') {
                    defaults = setRoomSetUp(data, defaults, mode);
                    params = Odigeo._.extend(defaults, {
                        departureLocation: data.searchSegments[0].departure.name,
                        departureDate: data.searchSegments[0].dateStr.split('-').reverse().join('/'),
                        arrivalLocation: data.searchSegments[0].destination.name,
                        departureLocationGeoNodeId: data.searchSegments[0].departure.geoNodeId,
                        arrivalLocationGeoNodeId: data.searchSegments[0].destination.geoNodeId,
                        returnDate: data.searchSegments[1].dateStr.split('-').reverse().join('/'),
                        filterDirectFlights: data.directFlightsOnly,
                    });
                    if (!Odigeo._.isNull(data.collectionMethod)) {
                        params = Odigeo._.extend(params, {
                            collectionMethodId: data.collectionMethod,
                        });
                    }

                    if (!!data.checkInDate && !!data.checkOutDate) {
                        params = Odigeo._.extend(params, {
                            accommodationCheckInDate: Odigeo.Utils.formatDateFromString(data.checkInDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                            accommodationCheckOutDate: Odigeo.Utils.formatDateFromString(data.checkOutDate, 'yyyy-mm-dd', 'dd/mm/yyyy'),
                        });
                    }

                    return baseUrl + '?' + $.param(params);
                } else {
                    return voidFunction;
                }
            };
    }
};

Flights.parseDynpackParams = function(data, defaults, mode) {
    var i;
    var j;
    var k;
    var rooms = data.rooms;
    var roomChildren;
    var roomInfants;
    var numberOfRooms = data.numberOfRooms;

    defaults[Flights.getNumberOfRoomsItem(mode)] = numberOfRooms;
    for (i = 0; i < numberOfRooms; i++) {
        roomChildren = rooms['roomKids' + i];
        roomInfants = rooms['roomInfants' + i];
        defaults[Flights.getRoomConfigItem(true, i, mode)] = rooms['roomAdults' + i];
        defaults[Flights.getRoomConfigItem(false, i, mode)] = roomChildren + roomInfants;
        for (j = 0; j < roomChildren; j++) {
            defaults[Flights.getRoomChildAge(i, j, mode)] = rooms['room' + i + 'Kid' + j + 'Age'];
        }
        for (k = 0; k < roomInfants; k++) {
            defaults[Flights.getRoomChildAge(i, k + j, mode)] = rooms['room' + i + 'Infant' + k + 'Age'];
        }
    }
    return defaults;
};

Flights.getRoomConfigItem = function(isAdult, index, mode) {
    switch (mode) {
        case 'GO':
        case 'OP':
            return (isAdult ? 'adt' : 'enf') + index;
        // 'ED' or anything else
        default:
            return 'room' + index + (isAdult ? 'Adults' : 'Childs');
    }
};

Flights.getRoomChildAge = function(room, child, mode) {
    switch (mode) {
        case 'GO':
        case 'OP':
            return 'ae' + (child + 1) + room;
        // 'ED' or anything else
        default:
            return 'room' + room + 'Child' + child + 'Age';
    }
};

Flights.getNumberOfRoomsItem = function(mode) {
    switch (mode) {
        case 'GO':
        case 'OP':
            return 'rooms';
        // 'ED' or anything else
        default:
            return 'numberOfRooms';
    }
};

Flights.dynpackParamsStringify = (function() {
    var baseUrl = Odigeo.SessionScope ? Odigeo.SessionScope.dynPackUrlBase : '';
    var voidFunction = function() {
        return '#';
    };
    var setRoomSetUp = function(data, defaults, mode) {
        var roomSetUp = Flights.validateRooms(data);
        var i;
        var j;
        var k;
        var numberOfRooms = roomSetUp.length;
        var roomItemSetUp;
        var roomChildren;
        var roomInfants;

        defaults[Flights.getNumberOfRoomsItem(mode)] = numberOfRooms;
        for (i = 0; i < numberOfRooms; i++) {
            roomItemSetUp = roomSetUp[i].split('_');
            roomChildren = parseInt(roomItemSetUp[1], 10);
            roomInfants = parseInt(roomItemSetUp[2], 10);
            defaults[Flights.getRoomConfigItem(true, i, mode)] = parseInt(roomItemSetUp[0], 10);
            defaults[Flights.getRoomConfigItem(false, i, mode)] = roomChildren + roomInfants;
            for (j = 0; j < roomChildren; j++) {
                defaults[Flights.getRoomChildAge(i, j, mode)] = 6;
            }
            for (k = roomChildren; k < (roomChildren + roomInfants); k++) {
                defaults[Flights.getRoomChildAge(i, k, mode)] = 1;
            }
        }
        return defaults;
    };

    if (!baseUrl) {
        return voidFunction;
    }

    return Flights.getDynpackSearchFunction(setRoomSetUp, voidFunction, baseUrl);
})();

Flights.getClosestAirports = () => Odigeo.Device.location.get()
    .then((pos) => Fetcher.get(getGeoData(pos)).json());

Flights.convertRequestFromSearchParams = (searchParams) => {
    let attrs = Odigeo._.clone(searchParams);
    const allowed = ['iata', 'name', 'geoNodeId', 'type'];

    if (attrs.type) {
        attrs.type = TYPES[attrs.type];
    }

    attrs.searchSegments = attrs.searchSegments.map((segment) => {
        return {
            departure: Odigeo._.pick(segment.departure, allowed),
            destination: Odigeo._.pick(segment.destination, allowed),
            dateStr: segment.dateStr,
            time: segment.time,
            timeWindow: segment.timeWindow,
        };
    });

    return Flights.convertRequest(attrs);
};

Flights.convertRequest = function(data) {
    var segmentRequests = [];
    var extraItinerarySearchRequestList = [];
    var newData = data;
    if (Odigeo._.isObject(data) && Odigeo._.has(data, 'type')) {
        segmentRequests = Odigeo._.reduce(data.searchSegments, function(memo, segment) {
            return memo.concat({
                dateStr: segment.dateStr,
                date: segment.dateStr,
                departure: segment.departure,
                destination: segment.destination,
                time: segment.time || '0000',
                timeWindow: segment.timeWindow || null,
            });
        }, []);
        const resident = Odigeo.AB.isResidentDiscount ? false : data.resident;
        newData = {
            itinerarySearchRequest: {
                type: data.type,
                numAdults: data.numAdults,
                numChildren: data.numChildren,
                numInfants: data.numInfants,
                cabinClass: data.cabinClass,
                mainAirportsOnly: data.mainAirportsOnly || false,
                directFlightsOnly: data.directFlightsOnly,
                resident,
                searchMainProductType: 'FLIGHT',
                airlinesCodes: data.airlinesCodes || [],
                externalSelectionRequest: data.externalSelectionRequest,
                dynpackSearch: false,
                segmentRequests: segmentRequests,
                urlSearch: Odigeo.History.location.href,
            },
            extraItinerarySearchRequestList: extraItinerarySearchRequestList,
            buyPath: data.buyPath,
            collectionMethod: data.collectionMethod,
        };

        if (Odigeo.AB.isOfferChildrenAgeDesktop) {
            var ageData = pickKidAndInfantAges(data, MAX_CHILDREN, MAX_INFANTS);
            Odigeo._.extend(newData.itinerarySearchRequest, ageData);
        }
        if (!Odigeo._.isUndefined(data.flexibleDates) && !Odigeo._.isNull(data.flexibleDates)) {
            newData.flexibleDates = data.flexibleDates;
        }
    }

    return newData;
};

Flights.getSearchDatesForCurrentRoundTripItinerary = () => {
    const flightSearchSegments = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'))?.searchSegments;

    return {
        departureDate: flightSearchSegments?.[0]?.dateStr,
        returnDate: flightSearchSegments?.[1]?.dateStr,
    };
};

Flights.convertXsellAccommodationRequest = function(params) {
    var data = params.data;

    const customCheckoutDate = xsellUtils.getPricePerceptionCheckoutDateIfPossible();

    return {
        itinerarySearchRequest: {
            externalSelectionRequest: {
                fareItineraryKey: data.fareItineraryKey,
                searchId: data.searchId,
                segmentKeys: data.flightNumbers,
                flightNumbers: data.flightNumbers,
                priceWithoutDiscountSelected: data.priceWithoutDiscountSelected,
                fareFamilyAmount: data.fareFamilyAmount,
                truncateAccommodationDates: params.truncateAccommodationDates,
                customCheckoutDate,
            },
        },
    };
};

Flights.convertXsellNewSearchAccommodationRequest = function(params) {
    var destination = params.accommodationDestination || params.searchSegments[0].destination;

    return {
        accommodationSearchRequest: {
            destination: {
                iata: destination.iata,
                name: destination.name,
                geoNodeId: destination.geoNodeId,
                type: destination.type,
            },
            checkInDate: params.checkInDate || params.searchSegments[0].dateStr,
            checkOutDate: params.checkOutDate || getCheckoutDateFromReturnFlight(params.searchSegments),
        },
    };
};

Flights.getExtraItinerary = function(value, type, itinerary) {
    var changedItinerary = jQuery.extend(true, {}, itinerary);
    if (type === 'departureCity') {
        changedItinerary.segmentRequests[0].destination = value;
        if (itinerary.segmentRequests.length > 1) {
            changedItinerary.segmentRequests[1].departure = value;
        }
    }
    return changedItinerary;
};

Flights.isAnywhereLocation = function(location) {
    return Odigeo._.isObject(location) &&
        location.iata === 'INSP' &&
        location.geoNodeId === 0;
};

Flights.hasAnywhereDestination = function(searchSegments) {
    return searchSegments.length > 0 &&
        Flights.isAnywhereLocation(searchSegments[0].destination);
};

Flights.getCollectionMethod = function() {
    var searchParams = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));

    return !Odigeo._.isNull(searchParams) && !Odigeo._.isNaN(+searchParams.collectionMethod) ?
        +searchParams.collectionMethod : 0;
};

module.exports = Flights;
